var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[{ 'is-active': _setup.props.isActive }],on:{"click":_setup.toggleClick}},[_c('svg-icon',{attrs:{"icon-class":"hamburger","width":"20","height":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }